import { render, staticRenderFns } from "./VuesticIconVuestic.vue?vue&type=template&id=912b66d4&"
import script from "./VuesticIconVuestic.vue?vue&type=script&lang=js&"
export * from "./VuesticIconVuestic.vue?vue&type=script&lang=js&"
import style0 from "./VuesticIconVuestic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticIconVuestic.vue"
export default component.exports